var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhgl"},[_vm._m(0),_c('Cont1'),_c('Cont2'),_c('Cont3'),_c('Cont4'),_c('Cont5')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"static/lvya/zhgl/banner.png","alt":""}})])
}]

export { render, staticRenderFns }